import { faSparkles } from '@fortawesome/pro-light-svg-icons';
import { IconBox, Link } from '~/common/components';
import { cx } from '~/common/utils';
import { useInitData } from '~/root/Auth';
import { useNavigation } from '~/root/Navigation/context';
import { MEDLY_SSO_URL, medlyGradientClassName } from './constants';

export const MedlyNavButton = () => {
  const { canUseMedly } = useInitData();
  const { isMenuCollapsed } = useNavigation();

  if (!canUseMedly) return null;

  return (
    <Link.Base
      href={MEDLY_SSO_URL}
      newTab
      data-tt={cx(isMenuCollapsed && 'Medly')}
      data-tt-placement="right"
      className={cx(
        'lg:mx-0 mx-2 flex items-center justify-between gap-2 px-2 py-[12px] rounded-md',
        'font-brand-l2 text-text-500 transition-opacity duration-300 hover:opacity-80',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-300',
        medlyGradientClassName,
      )}
    >
      <span className="flex items-center gap-1 min-w-0">
        <IconBox size="m" icon={faSparkles} className="text-info-300" />
        {!isMenuCollapsed && <span className="truncate">Medly</span>}
      </span>

      {!isMenuCollapsed && (
        <span className="rounded-2xl bg-success-100 text-success-300 px-1 py-[2px] text-[12px] leading-[20px] font-semibold uppercase">
          Pilot
        </span>
      )}
    </Link.Base>
  );
};
